import { api } from "./api"
import { locResponse, useLangRefetch } from "./utils"
import type { LangWrapHook } from "./types"
import type { components, WithId } from "./generated"

export type EventType = WithId<components["schemas"]["EventType"]>

const eventTypeApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getEventTypes: builder.query<EventType[], { classes?: boolean; populateClasses?: boolean } | void>({
			query: (params) => ({
				url: "/eventType",
				params: params ?? undefined,
			}),
			providesTags: (res) => {
				return ["EventType", "Loc", ...(res ? res.map((o) => ({ type: "EventType" as const, id: o._id })) : [])]
			},
			transformResponse: (...args) => locResponse(...args),
		}),
		getEventType: builder.query<EventType, { id: string; query?: Record<string, unknown> }>({
			query: ({ id, query }) => ({
				url: "/eventType/" + id,
				params: query,
			}),
			providesTags: (res) => [{ type: "EventType", id: res?._id }],
		}),
		getEventTypeByName: builder.query<EventType, { name: string; query?: Record<string, unknown> }>({
			query: ({ name, query }) => ({
				url: "/eventType/name",
				params: { ...query, name },
			}),
			providesTags: (res) => [{ type: "EventType", id: res?._id }],
		}),
		createEventType: builder.mutation<EventType, components["schemas"]["EventType"]>({
			query: (body) => ({
				url: "/eventType",
				method: "POST",
				body,
			}),
			invalidatesTags: ["EventType"],
		}),
		updateEventType: builder.mutation<EventType, { id: string; body: Partial<components["schemas"]["EventType"]> }>({
			query: ({ id, body }) => ({
				url: "/eventType/" + id,
				method: "PUT",
				body,
			}),
			invalidatesTags: (res) => ["RootGroupClass", { type: "EventType", id: res?._id }],
		}),
		deleteEventType: builder.mutation<void, string>({
			query: (id) => ({
				url: "/eventType/" + id,
				method: "DELETE",
			}),
			invalidatesTags: ["RootGroupClass", "EventType"],
		}),
	}),
})

export const {
	useGetEventTypesQuery,
	useGetEventTypeQuery,
	useCreateEventTypeMutation,
	useUpdateEventTypeMutation,
	useDeleteEventTypeMutation,
} = eventTypeApi

export const useGetEventTypesQueryL: LangWrapHook = (arg, options) => useLangRefetch(useGetEventTypesQuery, arg, options)
